module.exports = __webpack_public_path__ + "img/logo-twd.8d9c194c.svg";